import { mapDisadvantagedCommunity } from 'site-modules/shared/components/incentives/incentives-wizard/flow-builders/qualifier-question-mappers/disadvantaged-community-mapper';
import { mapAssistance } from 'site-modules/shared/components/incentives/incentives-wizard/flow-builders/qualifier-question-mappers/assistance-mapper';
import { mapBase } from 'site-modules/shared/components/incentives/incentives-wizard/flow-builders/qualifier-question-mappers/base-mapper';
import { mapFirstTimeBuyer } from 'site-modules/shared/components/incentives/incentives-wizard/flow-builders/qualifier-question-mappers/first-time-buyer-mapper';
import {
  ASSISTANCE,
  DISADVANTAGED_COMMUNITY,
  FILING_CURRENT_YEAR,
  FILING_PREVIOUS_YEAR,
  FIRST_TIME_BUYER_LESSEE,
  RIDESHARE,
  VEHICLE_RETIREMENT,
} from 'site-modules/shared/components/incentives/incentives-wizard/constants/qualifiers';
import { mapFilingPreviousYear } from 'site-modules/shared/components/incentives/incentives-wizard/flow-builders/qualifier-question-mappers/filing-previous-year-mapper';
import { mapFilingCurrentYear } from 'site-modules/shared/components/incentives/incentives-wizard/flow-builders/qualifier-question-mappers/filing-current-year-mapper';
import { mapVehicleRetirement } from 'site-modules/shared/components/incentives/incentives-wizard/flow-builders/qualifier-question-mappers/vehicle-retirement-mapper';
import { mapRideshare } from 'site-modules/shared/components/incentives/incentives-wizard/flow-builders/qualifier-question-mappers/rideshare-mapper';

export const getQualifierMapper = qualifier => {
  switch (qualifier.toLowerCase()) {
    case VEHICLE_RETIREMENT:
      return mapVehicleRetirement;
    case RIDESHARE:
      return mapRideshare;
    case DISADVANTAGED_COMMUNITY:
      return mapDisadvantagedCommunity;
    case ASSISTANCE:
      return mapAssistance;
    case FIRST_TIME_BUYER_LESSEE:
      return mapFirstTimeBuyer;
    case FILING_PREVIOUS_YEAR:
      return mapFilingPreviousYear;
    case FILING_CURRENT_YEAR:
      return mapFilingCurrentYear;
    default:
      return mapBase;
  }
};
